import React, { Component } from 'react';

import { withFirebase } from '../HOCs';

const withStorage = WrappedComponent => {
  class WithStorage extends Component {
    constructor(props) {
      super(props);
    }

    render() {
      return (
        <WrappedComponent
          storage={this.props.firebase.storage()}
          {...this.props}
        />
      );
    }
  }

  return withFirebase(WithStorage);
};

export default withStorage;
